import { AutoAwesome as AutoAwesomeIcon } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import {
  type AppliedRuleDisplay,
  type AppliedRuleStatus,
  formatRuleValue,
} from "../utils/agentRules";

const STATUS_CHIPS: Record<
  AppliedRuleStatus,
  { label: string; sx: Record<string, string> }
> = {
  applied: {
    label: "Applied",
    sx: { backgroundColor: "#e3f2fd", color: "#1976d2" },
  },
  overridden: {
    label: "Overridden",
    sx: {
      backgroundColor: "#fff8e1",
      color: "#ef6c00",
      border: "1px solid #ffcc02",
    },
  },
  advisory: {
    label: "Advisory",
    sx: { backgroundColor: "#f5f5f5", color: "#616161" },
  },
};

interface AppliedRulesDialogProps {
  rules: AppliedRuleDisplay[];
  open: boolean;
  onClose: () => void;
}

export default function AppliedRulesDialog({
  rules,
  open,
  onClose,
}: AppliedRulesDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <AutoAwesomeIcon sx={{ color: "#1976d2", fontSize: 20 }} />
          Benny payer rules for this verification
        </Box>
      </DialogTitle>
      <DialogContent data-testid="appliedRulesDialog">
        {rules.map((rule) => {
          const chip = STATUS_CHIPS[rule.status];
          return (
            <Box
              key={rule.field}
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={1}
              sx={{ py: 1 }}
            >
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {rule.label}
              </Typography>
              <Chip size="small" label={chip.label} sx={chip.sx} />
              {rule.condition && (
                <Chip
                  size="small"
                  variant="outlined"
                  label="Conditional"
                  sx={{ color: "#616161", borderColor: "#bdbdbd" }}
                />
              )}
              {rule.value !== null && rule.value !== undefined && (
                <Typography variant="body2">
                  Suggested: {formatRuleValue(rule.value)}
                </Typography>
              )}
              {rule.note && (
                <Typography variant="body2" sx={{ color: "#616161" }}>
                  {rule.note}
                </Typography>
              )}
              {rule.condition && (
                <Typography
                  variant="caption"
                  sx={{ color: "#616161", fontStyle: "italic", width: "100%" }}
                >
                  {rule.condition}
                </Typography>
              )}
            </Box>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
